import { ICardProps } from 'components/Card/Card'
import { TFunction } from 'react-i18next'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { IAuthRepsActionWithPastRepFlag } from './isPastRep'
import { isValidDateObject } from 'utils/dateAuthRep'

export const convertRepToCardListProp = (rep: IAuthRepsActionWithPastRepFlag, t: TFunction<'authRep'>) : ICardProps => {
  const displayValue = () => {
    if (rep.disclosurePeriod === 'disclose_indefinitely' || !rep.authEndDate) {
      return t('authRepView.card.noEndDate')
    }
    if (rep.isPastRep === true) {
      return `${t('authRepView.card.accessEnded')} ${rep.authEndDate.month}/${rep.authEndDate.day}/${rep.authEndDate.year}`
    } else {
      if (isValidDateObject(rep.authEndDate)) {
        return `${t('authRepView.card.accessEnd')} ${rep.authEndDate.month}/${rep.authEndDate.day}/${rep.authEndDate.year}`
      } else {
        return `${t('authRepView.card.noEndDate')}`
      }
    }
  }

  const buttonHref = `/account-settings/auth-rep/edit/${rep.id}`

  return ({
    title: rep.repFullName,
    displayValue: displayValue(),
    buttonCallbackOrHref: buttonHref,
    buttonText: t('authRepView.card.edit'),
    editButtonAriaLabel: `${t('authRepView.card.editButtonAriaLabel')} ${rep.repFullName}`,
    buttonSiteActivityProps: {
      component: 'Authorized Representative',
      clickData: {
        linkText: t('authRepView.card.edit', { lng: 'en' }),
        linkUrl: buildAbsoluteMedicareMyUrl(buttonHref)
      }
    },
    dropdown: {
      dropdownButtonProps: {
        expandButtonText: t('authRepView.card.viewDetails'),
        expandAriaLabel: `${t('authRepView.card.viewDetailsAriaLabel')} ${rep.repFullName}`,
        collapseButtonText: t('authRepView.card.hideDetails'),
        collapseAriaLabel: `${t('authRepView.card.hideDetailsAriaLabel')} ${rep.repFullName}`,
        openSiteActivityProps: {
          component: 'Authorized Representative',
          clickData: {
            linkText: `${t('authRepView.card.viewDetailsAriaLabel', { lng: 'en' })} ${rep.repFullName}`
          }
        },
        closeSiteActivityProps: {
          component: 'Authorized Representative',
          clickData: {
            linkText: `${t('authRepView.card.hideDetailsAriaLabel', { lng: 'en' })} ${rep.repFullName}`
          }
        }
      },
      contentId: `${rep.id}-content`,
      content: (
  <div className='ds-l-row'>
    <div className='ds-l-xs-col--12 ds-l-sm-col--6'>
      <div className='my-u-mb--4'>
        <strong>{rep.repAddress?.raw}</strong>
      </div>
      <div className='my-u-mb--4'>
        {t('authRepView.card.relationship')} <strong>{rep.repRelationshipToBene}</strong>
      </div>
      <div>
        {/* note: this is not currently in the backend? how do we get the start date? */}
        {t('authRepView.card.authStart')} <strong>{rep.authStartDate?.month ? `${rep.authStartDate.month}/${rep.authStartDate.day}/${rep.authStartDate.year}` : 'No start date'} </strong>
      </div>
      <div>
      {t('authRepView.card.authEnd')} <strong>{rep.disclosurePeriod === 'disclose_indefinitely' || !isValidDateObject(rep.authEndDate) ? t('authRepView.card.noEndDate') : `${rep.authEndDate?.month}/${rep.authEndDate?.day}/${rep.authEndDate?.year}`}</strong>
      </div>
    </div>
    <div className='ds-l-xs-col--12 ds-l-sm-col--6'>
    {rep.isPastRep ? t('authRepView.card.informationAboutPast') : t('authRepView.card.informationAbout')}
      {
        rep.disclosureLimitations.limitedInformation === 'any_information' ||
        (rep.disclosureLimitations?.isInfoMedicareClaimsChecked &&
        rep.disclosureLimitations?.isInfoMedicareAllowedChecked &&
        rep.disclosureLimitations?.isInfoPlanEnrollmentChecked &&
        rep.disclosureLimitations?.isInfoPremiumPaymentsChecked &&
        rep.disclosureLimitations?.isOtherSpecificInfoChecked)
        // eslint-disable-next-line operator-linebreak
          ?
          // eslint-disable-next-line react/jsx-indent
          <div>
            <strong>{t('authRepView.card.anyInformation')}</strong>
            <ul/>
          </div>
          // eslint-disable-next-line operator-linebreak
          :
          <ul className='rep-card-list'>
            {rep.disclosureLimitations?.isInfoMedicareClaimsChecked && <li><strong>{t('authRepView.card.claims')}</strong></li>}
            {rep.disclosureLimitations?.isInfoMedicareAllowedChecked && <li><strong>{t('authRepView.card.eligibility')}</strong></li>}
            {rep.disclosureLimitations?.isInfoPlanEnrollmentChecked && <li><strong>{t('authRepView.card.planEnrollment')}</strong></li>}
            {rep.disclosureLimitations?.isInfoPremiumPaymentsChecked && <li><strong>{t('authRepView.card.premiumPayments')}</strong></li>}
            {rep.disclosureLimitations?.isOtherSpecificInfoChecked && <li><strong>{t('authRepView.card.otherDetailed')}</strong></li>}
            {/* field below needs clarification */}
            {rep.disclosureLimitations?.isOtherSpecificInfoChecked && rep.disclosureLimitations?.otherSpecificInformation && <li><strong>{`${rep.disclosureLimitations.otherSpecificInformation}`}</strong></li>}
          </ul>
      }
      {
      rep.nyDrugInformation &&
      <>
        <div>
          {t('authRepView.card.nyStatusDetail')}
        </div>
        <div>
          <strong>
            {rep.nyDrugInformation === 'include_information' && t('authRepView.card.nyInclude')}
            {rep.nyDrugInformation === 'exclude_information' && t('authRepView.card.nyExclude')}
          </strong>
        </div>
      </>
        }
    </div>
  </div>)
    }
  })
}
